import { combineReducers } from "redux";

import { rolesDetails } from "./reducer.roles"
const roleReducers = combineReducers({

  rolesDetails

})
export default roleReducers;
